import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';

import { Store } from '@ngrx/store';
import { tap, filter, take, switchMap, catchError, map } from 'rxjs/operators';

import * as fromStore from '../store';
import { Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ContactEmployeesGuard  {
  constructor(private store: Store<fromStore.PeopleState>) {}

  canActivate(): Observable<boolean> {
    return this.checkStore().pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  canDeactivate(component: any, currentRoute: ActivatedRouteSnapshot, currentState: RouterStateSnapshot, nextState?: RouterStateSnapshot) {
    return this.store.select(fromStore.getEmployeesLoaded).pipe(
      tap(loaded => {
        if (loaded) {
          this.store.dispatch(fromStore.ClearEmployees());
        }
      }),
      filter(loaded => !loaded),
      map(loaded => !loaded),
      take(1)
    );
  }

  checkStore(): Observable<boolean> {
    return this.store.select(fromStore.getEmployeesLoaded).pipe(
      tap(loaded => {
        if (!loaded) {
          this.store.dispatch(fromStore.LoadContactEmployees());
        }
      }),
      filter(loaded => loaded),
      take(1)
    );
  }
}
